// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wAAAFtBlYUNBhcwI6PPS {
  width: 170px;
  min-width: 170px;
  height: calc(100vh - 14px);
  transition: width 0.3s ease-in-out;
  background-color: #007ca3;
  padding-top: 14px;
  top: 0;
  position: sticky;
  overflow: auto;
  overflow-x: hidden;
}

.KDTW2yhVbDOjZVchlrwZ {
  transition: width 0.3s ease-in-out;
  width: 34px;
  min-width: 34px;
}

.UMS2gONhDT6uUcnrCReB {
  display: flex;
  align-items: center;
  padding: 10px 6px;
  cursor: pointer;
  color: white;
  text-decoration: none;
  overflow: hidden;
}

.I8F1xCO3TB0omHdEaazK {
  background-color: #008fc5;
  font-weight: bold;
}

.dkGGhgmxobZjtHHxJ7GO {
  padding-left: 16px;
  overflow: hidden;
  white-space: nowrap;
}

.UMS2gONhDT6uUcnrCReB:hover {
  background-color: #244f7d1c;
}

.Xxd_m5Qk0g7Aop0nSgno {
  align-self: center;
  align-self: flex-start;
  justify-self: flex-end;
  color: #b2bac2;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding-left: 6px;
}

/* Phones: a sticky top bar, with the menu dropping down below it */
.jY6TnxdVvpL_oXee9i5v {
  position: sticky;
  top: 0;
  z-index: 1100;
  background-color: #007ca3;
}

.Y0S7dCWWDz9zgzMHdjcF {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 4px 4px 10px;
}

.xueykdHRMO5Npvcp861g {
  max-height: calc(100vh - 56px);
  overflow-y: auto;
  padding-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/style/sidenav.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;EAClC,yBAAyB;EACzB,iBAAiB;EACjB,MAAM;EACN,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EAEE,kCAAkC;EAClC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EAEE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA,mEAAmE;AACnE;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".sidenav {\n  width: 170px;\n  min-width: 170px;\n  height: calc(100vh - 14px);\n  transition: width 0.3s ease-in-out;\n  background-color: #007ca3;\n  padding-top: 14px;\n  top: 0;\n  position: sticky;\n  overflow: auto;\n  overflow-x: hidden;\n}\n\n.sidenavClosed {\n  composes: sidenav;\n  transition: width 0.3s ease-in-out;\n  width: 34px;\n  min-width: 34px;\n}\n\n.sideItem {\n  display: flex;\n  align-items: center;\n  padding: 10px 6px;\n  cursor: pointer;\n  color: white;\n  text-decoration: none;\n  overflow: hidden;\n}\n\n.sideItemSelected {\n  composes: sideItem;\n  background-color: #008fc5;\n  font-weight: bold;\n}\n\n.linkText {\n  padding-left: 16px;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.sideItem:hover {\n  background-color: #244f7d1c;\n}\n\n.menuBtn {\n  align-self: center;\n  align-self: flex-start;\n  justify-self: flex-end;\n  color: #b2bac2;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding-left: 6px;\n}\n\n/* Phones: a sticky top bar, with the menu dropping down below it */\n.topBar {\n  position: sticky;\n  top: 0;\n  z-index: 1100;\n  background-color: #007ca3;\n}\n\n.topBarHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 4px 4px 10px;\n}\n\n.mobileMenu {\n  max-height: calc(100vh - 56px);\n  overflow-y: auto;\n  padding-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidenav": `wAAAFtBlYUNBhcwI6PPS`,
	"sidenavClosed": `KDTW2yhVbDOjZVchlrwZ wAAAFtBlYUNBhcwI6PPS`,
	"sideItem": `UMS2gONhDT6uUcnrCReB`,
	"sideItemSelected": `I8F1xCO3TB0omHdEaazK UMS2gONhDT6uUcnrCReB`,
	"linkText": `dkGGhgmxobZjtHHxJ7GO`,
	"menuBtn": `Xxd_m5Qk0g7Aop0nSgno`,
	"topBar": `jY6TnxdVvpL_oXee9i5v`,
	"topBarHeader": `Y0S7dCWWDz9zgzMHdjcF`,
	"mobileMenu": `xueykdHRMO5Npvcp861g`
};
export default ___CSS_LOADER_EXPORT___;
